
        export default {
          name: 'ember-cli-mirage',
          initialize() {}
        };
      